import { post, get } from "../helpers/fetchServicesMethods"
import PubSub from 'pubsub-js';

function showLoader() {
    PubSub.publish('msg', true);
}

function hideLoader() {
    PubSub.publish('msg', false);
}

async function launchCMSearch(searchInfo) {
    showLoader();
    try{
        return await post(`do=gqft.launch_cm_search&format=json`, searchInfo)
           .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("Error launching CM search:", error);
    }
}

async function getSavedPattern(name) {
    let postData = {template_name: name};
    showLoader();
    try{
        return await post(`do=gqtemplate.get&context=GqWfCmSearch_pattern&template_name=[default]&format=json`, postData)
           .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("getting template:", error);
    }
}

async function getSavedPatternTemplate(name) {
    let postData = {template_name: name};
    showLoader();
    try{
        return await post(`do=gqtemplate.get&context=GqWfCmSearch_patterns&template_name=[default]&format=json`, postData)
           .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("getting template:", error);
    }
}

async function savePattern(searchInfo) {
    showLoader();
    try{
        return await post(`do=gqft.save_cm_template&context=GqWfCmSearch_pattern&format=json&view_helper=ObjectViewer::full`, searchInfo)
           .then((response) => {
               hideLoader();
               return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("Error saving template:", error);
    }
}

async function savePatternTemplate(searchInfo) {
    showLoader();
    try{
        return await post(`do=gqft.save_cm_template&context=GqWfCmSearch_patterns&format=json&view_helper=ObjectViewer::full`, searchInfo)
           .then((response) => {
               hideLoader();
               return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("Error saving template:", error);
    }
}

async function getCMTemplate(searchInfo) {
    let postData = {template_name: searchInfo};
    showLoader();
    try{
        return await post(`do=gqtemplate.get&context=GqWfCmSearch_launch&format=json`, postData)
           .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("getting template:", error);
    }
}

async function saveCMTemplate(searchInfo) {
    showLoader();
    try{
        return await post(`do=gqft.save_cm_template&context=GqWfCmSearch_launch&format=json&view_helper=ObjectViewer::full`, searchInfo)
           .then((response) => {
               hideLoader();
               return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("Error saving template:", error);
    }
}

async function submitCMSearch(searchInfo) {
    showLoader();
    try{
        return await post(`do=gqworkflow.submit_seq_search&workflow_type=GqWfCmSearch&format=json&view_helper=ObjectViewer::full`, searchInfo)
           .then((response) => {
               hideLoader();
               return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("Error submitting CM search:", error);
    }
}

async function deleteCMTemplate(name) {
    showLoader();
    try {
        return await get(`do=gqtemplate.delete&context=GqWfCmSearch_launch&template_name=${encodeURIComponent(name)}&format=json`)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        console.error("Error deleting CM template:", error);
    }
}

async function deletePattern(name) {
    showLoader();
    try {
        return await get(`do=gqtemplate.delete&context=GqWfCmSearch_pattern&template_name=${encodeURIComponent(name)}&format=json`)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        console.error("Error deleting pattern:", error);
    }
}

async function deletePatternTemplate(name) {
    showLoader();
    try {
        return await get(`do=gqtemplate.delete&context=GqWfCmSearch_patterns&template_name=${encodeURIComponent(name)}&format=json`)
            .then((response) => {
                hideLoader();
                return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
        console.error("Error deleting pattern template:", error);
    }
}

async function redoCMSearch(id) {
    showLoader();
    try{
        return await post(`do=gqft.launch_cm_search&format=json`, { parent_id: id })
           .then((response) => {
               hideLoader();
               return response;
            })
            .catch((error) => {
                hideLoader();
                console.log("error::", error);
            });
    } catch (error) {
      console.error("Error redo CM search:", error);
    }
}

const CMSearchService = {
    launchCMSearch,
    redoCMSearch,
    getSavedPattern,
    getSavedPatternTemplate,
    savePattern,
    savePatternTemplate,
    getCMTemplate,
    saveCMTemplate,
    submitCMSearch,
    deleteCMTemplate,
    deletePattern,
    deletePatternTemplate
}

export default CMSearchService;
